import React from 'react';
import SEO from '../components/SEO';
import { useLanguage } from '../components/LanguageContext';

const ConsentPage = () => {
  const { language } = useLanguage();

  const content = {
    da: {
      seoTitle: "Samtykkeerklæring for Helbredsoplysninger",
      seoDesc: "Læs Alora Rejsers samtykkeerklæring. Vi indhenter samtykke til behandling af helbredsoplysninger for at sikre en fuldstændig tryg og tilpasset handicaprejse.",
      title: "Samtykkeerklæring",
      lead: "Tydeligt samtykke vedrørende behandling af helbredsoplysninger.",
      whyTitle: "Hvorfor har vi brug for dit samtykke?",
      whyText: "For at kunne arrangere en tryg og tilgængelig rejse til dig, har vi brug for at vide præcis, hvilke behov du har. Dette inkluderer information om din mobilitet, din kørestol (inkl. batteritype til flyselskabet) og eventuelle behov for pleje eller specialudstyr på værelset.",
      whatTitle: "Hvad giver jeg samtykke til?",
      whatIntro: "Ved at acceptere samtykkeerklæringen giver du Alora Rejser lov til at:",
      whatItems: [
        "Indsamle og opbevare oplysninger om din funktionsnedsættelse og hjælpemidler.",
        "Videregive nødvendige oplysninger til flyselskaber for at sikre korrekt assistance og transport af kørestol.",
        "Videregive oplysninger til hoteller for at sikre booking af korrekt værelsestype (handicapværelse).",
        "Videregive oplysninger til lokale transportselskaber for booking af liftbus eller specialtransport."
      ],
      withdrawTitle: "Tilbagekaldelse",
      withdrawText: "Du kan til enhver tid trække dit samtykke tilbage ved at kontakte os. Vær dog opmærksom på, at hvis du trækker dit samtykke tilbage, kan vi muligvis ikke længere gennemføre din rejse, da vi ikke kan sikre de nødvendige tilgængelighedsforhold."
    },
    en: {
      seoTitle: "Consent Form for Health Information",
      seoDesc: "Read Alora Rejser's consent form. We obtain consent for processing health information to ensure a completely safe and customized accessible holiday.",
      title: "Consent Form",
      lead: "Explicit consent regarding the processing of health and medical information.",
      whyTitle: "Why do we need your consent?",
      whyText: "To arrange a safe and accessible trip for you, we need to know exactly what needs you have. This includes information about your mobility, your wheelchair (including battery type for the airline), and any need for care or special equipment in the room.",
      whatTitle: "What am I consenting to?",
      whatIntro: "By accepting this consent form, you authorize Alora Rejser to:",
      whatItems: [
        "Collect and store information about your disability and assistive devices.",
        "Disclose necessary information to airlines to ensure correct assistance and wheelchair transportation.",
        "Disclose information to hotels to ensure booking of the correct room type (accessible room).",
        "Disclose information to local transport companies for booking lift buses or specialized transport."
      ],
      withdrawTitle: "Withdrawal of Consent",
      withdrawText: "You can withdraw your consent at any time by contacting us. Please note, however, that if you withdraw your consent, we may no longer be able to carry out your trip, as we cannot guarantee the necessary accessibility conditions."
    }
  };

  const t = content[language] || content.da;

  return (
    <div className="pt-32 pb-20 px-4 min-h-screen bg-white relative">
      <SEO 
        title={t.seoTitle} 
        description={t.seoDesc}
      />
      {/* Weak background image overlay */}
      <div 
        className="absolute inset-0 z-0 opacity-15 pointer-events-none fixed"
        style={{
          backgroundImage: 'url("https://assets.auxodev.dk/assets/1a80aa53-8838-4db9-a7e2-061c5ee04d6a/378a20d8-af7c-4ed6-9273-84c31896612e.jpg")',
          backgroundPosition: 'center',
          backgroundSize: 'cover'
        }}
      ></div>
      <div className="max-w-4xl mx-auto prose prose-stone relative z-10">
        <h1 className="font-serif text-[#99A18C]">{t.title}</h1>
        <p className="lead text-xl text-gray-600">
          {t.lead}
        </p>

        <section className="mt-12 space-y-8">
          <div className="bg-stone-50 p-8 rounded-2xl border border-[#99A18C]/20">
            <h2 className="text-xl font-bold text-[#99A18C] mb-4">{t.whyTitle}</h2>
            <p className="text-gray-700">
              {t.whyText}
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-serif text-[#99A18C]">{t.whatTitle}</h2>
            <p>{t.whatIntro}</p>
            <ul>
              {t.whatItems.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-serif text-[#99A18C]">{t.withdrawTitle}</h2>
            <p>
              {t.withdrawText}
            </p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default ConsentPage;
